import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { getAbout } from '../../store/thunks/aboutThunk';
import { setData } from '../../store/slices/aboutSlice';
import { useNavigate } from 'react-router-dom';
import { updateStatusAboutImage } from '../../services/about_Images';
import { logout } from '../../store/thunks/authThunks';

const AboutImages = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { list, total, loading, error } = useSelector((state) => state.about);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const token = useSelector((state) => state.auth.token);
  
  useEffect(() => {
    if (token) {
      dispatch(getAbout({ page, limit: rowsPerPage, sortField, sortOrder }));
    }    
  }, [dispatch, page, rowsPerPage, sortField, sortOrder, token]);

  useEffect(() => {
    if(error && error.toLowerCase()==='invalid token'){
      handleLogout();
    }    
  }, [error]);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const columns = [
    { name: 'Image Name', selector: (row) => row.name, sortable: true, sortField: 'name' },
    { name: 'Active', selector: (row) => row.active, sortable: false, cell: (row) => (
      <label className="inline-flex items-center cursor-pointer relative">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={row.active}
          onChange={() => handleToggle(row)}
        />
        <div className="w-11 h-6 bg-gray-200 rounded-full peer-checked:bg-green-500 transition-colors"></div>
        <div className="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5"></div>
      </label>
    ) }
  ];

  const handleToggle = async (row) => {
    await updateStatusAboutImage(row._id, !row.active, token.token)
    .then(response=>{
      if(response?.data?.success){
        const updatedList = list.map(item => 
          item._id === row._id ? { ...item, active: !item.active } : item
        );
    
        dispatch(setData({data: updatedList, total: total}))
      }
    })
    .catch(error=>{
      console.log(error);
      if(error.response?.data?.error && error.response?.data?.error.toLowerCase()==='invalid token'){
        handleLogout();
      }    
    });
  };

  const handleAddImage = () => {
    navigate('/about-images/add'); // or open modal instead
  };

  return (
    <div className="p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">About Images</h2>
          <button
            onClick={handleAddImage}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            + Add Image
          </button>
        </div>
        <DataTable
          columns={columns}
          data={list}
          progressPending={loading}
          pagination
          paginationServer
          paginationPerPage={rowsPerPage}
          paginationTotalRows={total}
          onChangePage={(page) => setPage(page)}
          onChangeRowsPerPage={(newPerPage, page) => {
            setRowsPerPage(newPerPage);
            setPage(page);
          }}
          onSort={(column, sortDirection) => {
            setSortField(column.sortField);     // or column.name if API expects field name
            setSortOrder(sortDirection);
          }}
          highlightOnHover
          pointerOnHover
          striped
        />
    </div>
  )
}

export default AboutImages
